module.exports = __webpack_public_path__ + "img/template_fb.4d14db47.png";